export default __webpack_public_path__ + "img/pin_icons/bell_w.png";